var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceBigReservationcomponent = function SvgWorkspaceBigReservationcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#14B5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 13.75h1.5v-1.5h-1.5v1.5Zm1.5 3h-1.5v-1.5h1.5v1.5Zm0 3h-1.5v-1.5h1.5v1.5Zm12-3h-10.5v-1.5h10.5v1.5Zm-10.5 3h10.5v-1.5h-10.5v1.5Zm0-6v-1.5h10.5v1.5h-10.5Z",
    fill: "#fff"
  })));
};
export default SvgWorkspaceBigReservationcomponent;